import { render, staticRenderFns } from "./DecorationPersonnelInformation.vue?vue&type=template&id=4146da10&scoped=true&"
import script from "./DecorationPersonnelInformation.vue?vue&type=script&lang=js&"
export * from "./DecorationPersonnelInformation.vue?vue&type=script&lang=js&"
import style0 from "./DecorationPersonnelInformation.vue?vue&type=style&index=0&id=4146da10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146da10",
  null
  
)

export default component.exports